import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { MDBBtn } from "mdbreact";
import axios from "axios";
import "../../style/Login.css";

import { useToasts } from "react-toast-notifications";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function OubliMdp() {
  const [email, setEmail] = useState();
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const { addToast } = useToasts();

  const handleSubmit = () => {
    setDisabledBtn(true);
    axios
      .put(`${API_URL}/api/auth/reset-mdp`, { email })
      .then((res) => {
        setEmail("");
        setRedirect(true);
        addToast(res.data.message, {
          appearance: "success",
          autoDismiss: true,
        });
      })
      .catch((e) => {
        setEmail("");
        setDisabledBtn(false);
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "success",
          autoDismiss: true,
        });
      });
  };

  return (
    <div className="loginContainer">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Mot de passe oublié</title>
      </Helmet>
      {redirect && <Redirect to="/login" />}
      <h1>Mot de passe oublié</h1>
      <div className="loginContainer2">
        <label htmlFor="email">
          Merci de renseigner votre adresse e-mail :
        </label>
        <input
          type="email"
          placeholder="Votre adresse électronique"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          required
        />
        <MDBBtn
          color="primary"
          type="button"
          disabled={email ? disabledBtn : true}
          onClick={() => handleSubmit()}
        >
          Valider
        </MDBBtn>
        Un mail vous sera envoyé pour réinitialiser votre mot de passe.
      </div>
    </div>
  );
}

export default OubliMdp;
